// Central business info — change in one place to update the whole site.
export const BUSINESS = {
    name: "Kayseri Su Tesisatı",
    phoneRaw: "05054950178",
    phonePretty: "0505 495 01 78",
    whatsappIntl: "905054950178",
    city: "Kayseri",
    tagline: "7/24 Acil Tesisat Servisi",
};

export const telHref = `tel:${BUSINESS.phoneRaw}`;
export const waHref = `https://wa.me/${BUSINESS.whatsappIntl}?text=${encodeURIComponent("Merhaba, su tesisatı hizmeti almak istiyorum.")}`;
